export default "__VITE_ASSET__BBJJxkM$__"